export interface FieldValidatorState {
  $invalid: boolean;
}

export interface FieldValidationNode {
  $dirty: boolean;
  [validatorName: string]: unknown;
}

export type FieldErrorMessages = Record<string, string>;

export function resolveFieldError (
  node: FieldValidationNode | null | undefined,
  messages: FieldErrorMessages,
  order: readonly string[] = Object.keys(messages),
): string {
  if (!node?.$dirty) {
    return '';
  }

  for (const validatorName of order) {
    const validator = node[validatorName] as FieldValidatorState | undefined;

    if (validator?.$invalid) {
      return messages[validatorName] ?? '';
    }
  }

  return '';
}
